const FEEDBACK_RECEIVED = 'Your feedback has been received and it will help us improve the Crimson app. Thank you!';
export default FEEDBACK_RECEIVED;
